/*========================================================================
 * $Id: constrainedchannels.js 76458 2013-11-12 09:34:35Z jakob.praher $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define ([
    "underscore",
    "service/channel",
    "backbone"
  ], function (
    _,
    Channel,
    Backbone
  ) {


    var ConstrainedChannelResponseObserver = function (responseObserver, constrainedChannel) {
      this.on("all", function (event, responseOrERrror, channel) {
        if (responseObserver) {
          var args = _.toArray(arguments);
          args[2] = constrainedChannel;
          responseObserver.trigger.apply(responseObserver, args);
        }
      });
    }
    _.extend(ConstrainedChannelResponseObserver.prototype, Backbone.Events);
    
  var ConstrainedChannel = Channel.extend({

    initialize: function(attrs, options) {
      Channel.prototype.initialize.apply(this, arguments);
      this.set("id", this.get("url") + "#" + escape(JSON.stringify(options.constraint, null, 1)));
      
      this.constraint = options.constraint;
      this.channel = options.channel;
      this.requestTransformers = options.requestTransformers || [];
    },
    
    // set global constraint on all calls
    setConstraint: function(constraint) {
      this.constraint = constraint;
    },

    getConstraint: function() {
      return this.constraint;
    },
    
    addConstraintsToRequest: function(request) {
      if (this.constraint) {
        if (!request.source_context) {
          request.source_context = {};
        }
        
        var constraint = this.constraint; 
        request.source_context.constraints = request.source_context.constraints || [];
        request.source_context.constraints.push(constraint);
      }
      return request;
    },

     // call is the method that is implemented by a channel in order to
    // get a response for that request.
    //
    // @param request  - a JSON object representing the requeest
    // @param ctx      - an object that is carried around for identifying the same objects
    // @return         - a promise that the call
    
    call: function (path, request, responseObserver, formatOptions, headers, options) {
      if (!this.get("enabled")) return;
      if (!this.channel) return;

      var innerResponseObserver = new ConstrainedChannelResponseObserver(responseObserver, this);
      // prepareRequest triggers the generic channels prepration ...
      // var request = this.prepareRequest(request);
      request = this.addConstraintsToRequest(request);
      for (var i = 0; i < this.requestTransformers.length; ++i) {
        request = this.requestTransformers[i](this, request, {path: path});     
      }

      var args = _.toArray(arguments);
      args[1] = request;     
      args[2] = innerResponseObserver; 
      return this.channel.call.apply(this.channel, args);
    }
  });


  ConstrainedChannel.createConstrained = function(channel, constraint) {
    return new ConstrainedChannel(null, {channel: channel, pathconstraint: constraint});
  }
    
  return ConstrainedChannel;
});
